import Typography from "@mui/material/Typography";
import styles from "./About.module.scss";

interface AboutProps {
  titlePrefix?: string;
  title: string;
  description?: string;
}

function About({ titlePrefix, title, description }: AboutProps) {
  if (!description) {
    return <></>;
  }

  return (
    <div className={styles.about}>
      <Typography
        variant="body1"
        className={styles.title}
      >
        {titlePrefix} {title}
      </Typography>
      <Typography
        variant="body1"
        className={styles.description}
      >
        {description}
      </Typography>
    </div>
  );
}

export default About;
